import React, {Component} from 'react';
import Cart from "../components/Cart";
import Login from "./Login";
import {isMobile} from 'react-device-detect';
import {withRouter} from 'react-router-dom';
import {withAlert} from 'react-alert';
import {getUser} from "../auth/Auth";
import {getCartProducts, getServiceCharge, loadProduct, updateCart} from "../common/Common";
import {postRequest} from "../routes/Routes";
import '../assets/css/Home.css';

class Checkout extends Component {
    constructor(props) {
        super(props);
        this.state = {user: null, total: 0.00, serviceCharge: 0.00, subTotal: 0.00, products: [], loading: false};
    }

    componentDidMount() {
        getUser().then(data => {
            this.setState({user: data});
        }).catch(() => null);
        this.getCart();
    }

    render() {
        return (
            <div className="container category-list partner-list">
                <h1 className="heading">Checkout</h1>
                <hr/>
                <div className="d-flex bd-highlight w-100">
                    <div className="p-2 flex-fill bd-highlight checkout-cart">
                        <Cart component="Checkout" getCart={this.getCart}/>
                    </div>
                    {!isMobile ? <div className="vertical-line"/> : null}
                    <div className="p-2 flex-fill bd-highlight checkout-form">
                        {this.state.user ?
                            this.state.products.length > 0 ?
                                <form onSubmit={this.checkoutFunction}>
                                    <div className="form-group">
                                        <label htmlFor="address">Address*</label>
                                        <input type="text" className="form-control" placeholder='Address' id="address"
                                               defaultValue={this.state.user.address} required/>
                                    </div>
                                    <div className="form-group">
                                        <label htmlFor="city">City*</label>
                                        <input type="text" className="form-control" placeholder='City' id="city"
                                               defaultValue={this.state.user.city} required/>
                                    </div>
                                    <div className="form-group">
                                        <label htmlFor="phone">Phone*</label>
                                        <input type="tel" className="form-control" placeholder='Phone' id="phone"
                                               pattern="[0-9]{10}" defaultValue={this.state.user.phone} required/>
                                        <small id="phone" className="form-text text-muted">
                                            Please follow the pattern (0771234567)
                                        </small>
                                    </div>
                                    <div className="form-group">
                                        <label htmlFor="notes">Notes</label>
                                        <textarea className="form-control custom-textarea" placeholder='Notes'
                                                  id="notes"/>
                                        <small id="notes" className="form-text text-muted">
                                            Any notes for the order
                                        </small>
                                    </div>
                                    <button className="btn blue-button login-button" disabled={this.state.loading}>
                                        {this.state.loading ?
                                            <span className="spinner-grow spinner-grow-sm ml-1" role="status"
                                                  aria-hidden="true"/>
                                            : null
                                        }
                                        Checkout Rs.{this.state.total}
                                    </button>
                                </form>
                                :
                                <h5 className="checkout-form-details" key="heading">
                                    No items in the cart
                                </h5>
                            : [
                                <h5 className="checkout-form-details" key="heading">
                                    Login to your account to continue with the checkout process
                                </h5>,
                                <Login component="Checkout" key="login"/>
                            ]
                        }
                    </div>
                </div>
            </div>
        );
    };

    getCart = () => {
        getCartProducts().then(data => {
            let total = 0.00,
                subTotal = 0.00,
                products = [];
            data.forEach((product, index, array) => {
                loadProduct(product.id).then(data => {
                    total += data.price * product.quantity;
                    subTotal += data.price * product.quantity;
                    products.push({quantity: product.quantity, price: data.price, product: {id: product.id}});
                    if (products.length === array.length) {
                        let serviceCharge = getServiceCharge(total);
                        total += serviceCharge;
                        this.setState({
                            total: total,
                            products: products,
                            serviceCharge: serviceCharge,
                            subTotal: subTotal
                        });
                    }
                }).catch(() => null);
            });
        }).catch(() => null);
    }

    checkoutFunction = async (event) => {
        event.preventDefault();
        this.setState({loading: true});
        let values = {
            address: event.target.address.value,
            city: event.target.city.value,
            phone: event.target.phone.value,
            notes: event.target.notes.value,
            sub_total: this.state.subTotal,
            service_charge: this.state.serviceCharge,
            email: this.state.user.email,
            products: this.state.products,
            endpoint: '/api/orders',
            token: this.state.user.api_token
        };
        postRequest(values).then(response => {
            if (response.status === 200) {
                if (response.data.error) {
                    this.props.alert.error(response.data.message);
                } else {
                    this.props.alert.success("Successfully Placed Order");
                    updateCart([]);
                    this.props.history.go(
                        this.props.history.push({
                            pathname: "/account"
                        })
                    );
                }
            } else {
                this.props.alert.error(response.data.message);
            }
            this.setState({loading: false});
        });
    }
}

export default withAlert()(withRouter(Checkout));